export default "__VITE_ASSET__n6l7Nlox__$_?url__"